import { ReadonlyURLSearchParams } from "next/navigation";

import {
  addQueryParameters,
  removeQueryParameter
} from "../helpers/query-parameter";
import { CHATBOT_SEARCH_PARAMETER } from "./constants";

type ChatBotRouter = {
  back: () => void;
};

export const openChatBot = (searchParameters: ReadonlyURLSearchParams) => {
  window.history.pushState(
    { modalEntry: true },
    "",
    `${addQueryParameters(searchParameters, {
      [CHATBOT_SEARCH_PARAMETER]: "true"
    })}`
  );
};

export const closeChatBot = (
  searchParameters: ReadonlyURLSearchParams,
  router: ChatBotRouter
) => {
  if (window.history.state?.modalEntry) {
    router.back();
    return;
  }

  window.history.replaceState(
    {},
    "",
    `${removeQueryParameter(searchParameters, CHATBOT_SEARCH_PARAMETER)}`
  );
};

export const toggleChatBot = (
  searchParameters: ReadonlyURLSearchParams,
  router: ChatBotRouter
) => {
  if (searchParameters.has(CHATBOT_SEARCH_PARAMETER)) {
    closeChatBot(searchParameters, router);
    return;
  }

  openChatBot(searchParameters);
};
